module.exports = __webpack_public_path__ + "img/ep-6-9.2ce2c067.jpg";